jQuery(document).ready(function () {

    $('.custom-header .list-menu li').each(function () {
        if( jQuery(this).find(".mega-menu").length >= 1 ){
            jQuery(this).addClass("has-submenu");
        }      
    });
  
    if ($(window).width() > 990) {
        jQuery(".mega-menu .category-menu-list .mega-menu-item").mouseenter(function () {
            var target_id = jQuery(this).attr("id");
            jQuery(this).closest(".first-mega-menu").find(".category-img .mega-menu-item").fadeOut(200);
            jQuery(this).closest(".first-mega-menu").find("#"+target_id).fadeIn(200);
        });
    }

    jQuery(".accordion .accordion-main:first-child").addClass("open");
    jQuery(".accordion-title-trigger").click(function (e) {
        if (!jQuery(this).closest(".accordion-main").hasClass("open")) {
            jQuery(this)
                .closest(".extender-accordion")
                .find(".accordion-main")
                .removeClass("open");
            jQuery(this)
                .closest(".extender-accordion")
                .find(".accordion-description")
                .slideUp("open");
        }
        jQuery(this).closest(".accordion-main").toggleClass("open");
        jQuery(this).next().slideToggle("slow");
    });
    // login form
    jQuery(".forgot-password").click(function (e) {
        jQuery(".login-form").fadeOut();
        jQuery(".reset-password-box").fadeIn(500);
    });
    jQuery(".cancel").click(function (e) {
        e.preventDefault();
        jQuery(".reset-password-box").fadeOut();
        jQuery(".login-form").fadeIn(500);
    });

    // product-swiper
    var productSwiper = new Swiper(".product-swiper", {
        slidesPerView: 4.5,
        slidesPerGroup: 1,
        spaceBetween: 12,
        loop: true,

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });

    // Home Hero slider
    var swiper = new Swiper(".hero-swiper", {
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
    // Home service slider
    var swiper = new Swiper(".service-slider-box", {
        loop: true,
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 48,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1.5,
                slidesPerGroup: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 48,
            }
        },
    });
    // Latest Updates slider
    if ($(window).width() < 767) {
        var swiper = new Swiper(".latest-updates-slider", {
            loop: true,
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 24,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            slideToClickedSlide: true,
            pagination: false,
        });
    }
    // product page slider
    if ($(window).width() < 991) {
        var swiper = new Swiper(".gummies-slider", {
            loop: true,
            slidesPerView: 2.5,
            slidesPerGroup: 1,
            spaceBetween: 12,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            slideToClickedSlide: true,
            pagination: false,
        });
    }

    // product Detail slider
    if( $(".product__media-wrapper .thumbnail-slider .swiper-slide").length < 4 ){
      $(".product__media-wrapper .swiper-button-next, .product__media-wrapper .swiper-button-prev").addClass("hide-arrow-button");
    }
    if ($(window).width() < 767) {
        var swiper = new Swiper('.thumbnail-slider', {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 12,
            // mousewheel: true,
            grabCursor: true,
            loop: true,
            navigation: {
                nextEl: '.product__media-wrapper .swiper-button-next',
                prevEl: '.product__media-wrapper .swiper-button-prev',
            },
        });
    }
    else {
        var swiper = new Swiper('.thumbnail-slider', {
            direction: 'vertical',
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 24,
            mousewheel: true,
            grabCursor: true,
            loop: true,
            navigation: {
                nextEl: '.product__media-wrapper .swiper-button-next',
                prevEl: '.product__media-wrapper .swiper-button-prev',
            },
        });
    }


    // cart page slider    
    var swiper = new Swiper(".custom-cart-collection", {
        loop: true,
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 12,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        breakpoints: {
            320: {
                slidesPerView: 2.5,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 3.5,
                spaceBetween: 12,
            }
        },
    });
    // Home page Hero section
    $('.hero-mouse').click(function (event) {
        event.preventDefault();

        var nextSection = $(this).parents(".shopify-section").next('section');
        if (nextSection.length) {
            $('html, body').animate({
                scrollTop: nextSection.offset().top
            }, 1000);
        }
    });
    // review slider
    var swiper = new Swiper(".review-slide", {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 24,
        allowTouchMove: true,
        speed: 10000,
        autoplay: {
            delay: 0,
            pauseOnMouseEnter: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1.6,
                centeredSlides: true,
                spaceBetween: 12,
                autoplay: {
                    delay: 0,
                },
            },
            575: {
                slidesPerView: 3.4,
                spaceBetween: 12,
                centeredSlides: true,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 24,
                centeredSlides: false,
            },
            992: {
                slidesPerView: 3.5,
            },
        },
    });
  if ($(window).width() < 991) {
    // accordion mega menu  
     $('.has-submenu a').on('click', function (e) {
      if ($(this).next('.mega-menu').length > 0) {
        e.preventDefault();
        $(this).next('.mega-menu').slideToggle();
        $('.mega-menu').not($(this).next()).slideUp();
      }
    });  
  }


// age popup
  function setCookie(Cookiename, Cookievalue, Cookiepath) {
      var d = new Date();
      d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days
      var expires = "expires=" + d.toGMTString();
      document.cookie = Cookiename + "=" + Cookievalue + "; " + expires + "; path=" + Cookiepath;
  }

  // get Cookies function
  function getCookie(Cookiename) {
      var name = Cookiename + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1);
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  
  if (getCookie('popupShown') == 'closed') {
      jQuery('.age-popup').hide();
  }else{
      jQuery('.age-popup').show();
  }
  
  jQuery('#age-verify-btn').click(function () {
      jQuery('.age-popup').hide();
      // setCookie('popupShown', 'closed', 30);
    setCookie('popupShown', 'closed', '/');

  });

  
    
  });